export const AuthServerNotificationTags = Object.freeze({
  AuthRequest: "authRequest",
});
